/* eslint-disable security/detect-object-injection */
import React, { useContext, useEffect, useState } from 'react';
import AnimatedPageFade from '../../components/Animations/AnimatedPageFade';
import ChoiceSection from '../../components/ChoiceSection';
import ApplicationContext from '../../context/ApplicationContext';
import InsuranceHeader from './InsuranceHeader';
import BackButton from '../../components/Button/BackButton';
import { insuranceLanguageContent } from './InsuranceLanguageContent';

function InsurancePhotoChoice(props) {
    const { handlePage, insuranceIndex, insurances, setLoading, setInsuranceIndex, sessionData, selectedLanguage } = useContext(ApplicationContext);
    
    const [selectedChoice, setSelectedChoice] = useState('');

    const handleNavigation = (choice) => {
        if(choice === 'Upload') {
            handlePage('upload_insurance_images', '', insuranceIndex || 0, sessionData['review'] === 'previous' ? 'previous' : '')
        } else {
            handlePage('take_insurance_front_image', '', insuranceIndex || 0, sessionData['review'] === 'previous' ? 'previous' : '')
        }
    }

    const handleBackNavigation = () => {
        if(insuranceIndex < 1) {
            handlePage('insurance');
        } else {
            setLoading(true);
            setInsuranceIndex(insuranceIndex - 1)
            handlePage('insurance_details', '', `${insuranceIndex - 1} ${insurances[insuranceIndex - 1]._id}`)
        }
    }

    return (
        <AnimatedPageFade className='flex flex-col justify-between relative h-welcome gradient-bg rounded-[16px] overflow-auto'>
            <InsuranceHeader />
            <div className='p-[8px] overflow-x-hidden overflow-y-auto options-height Form-scroll mt-[18px] '>
                <div className='mx-[12px] '>
                    {insuranceLanguageContent['insurance-photo-choice'][selectedLanguage]}
                    <div className='mt-[38px]'>
                        <ChoiceSection question="" choice1="Upload" choice2="Take a photo"  selectedChoice={selectedChoice} setSelectedChoice={setSelectedChoice} event="id" callback={true} handleNext={handleNavigation} />
                    </div>
                </div>
            </div>
            <div className='flex mb-[24px] justify-between mx-[16px] w-[40%] fold-gap pt-[20px]'>
                <BackButton handleClick={() => {handleBackNavigation()}}  backType="previous" />
            </div>
        </AnimatedPageFade>
    );
}

export default InsurancePhotoChoice;